export default __webpack_public_path__ + "static/media/stories-arrow.5d0eaea1.svg";